/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterArtOrientation_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuMultiSelectList_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuFilterArtOrientation_itemSearch";
};
export type SbSharedRefineMenuFilterArtOrientation_itemSearch$data = SbSharedRefineMenuFilterArtOrientation_itemSearch;
export type SbSharedRefineMenuFilterArtOrientation_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuFilterArtOrientation_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterArtOrientation_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilterArtOrientation_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectList_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '505b3f5b904af9d3ae24116f8321dc2c';
export default node;
